import { render, staticRenderFns } from "./ChapterTree.vue?vue&type=template&id=0d33a32e&scoped=true&"
import script from "./ChapterTree.vue?vue&type=script&lang=js&"
export * from "./ChapterTree.vue?vue&type=script&lang=js&"
import style0 from "./ChapterTree.vue?vue&type=style&index=0&id=0d33a32e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d33a32e",
  null
  
)

export default component.exports